import React, {useEffect, useState, useMemo} from 'react'
import _ from 'lodash'
import {Modal} from '@material-ui/core'

import {searchEntityFieldTypes} from '../../../../state/entities/search-entity-field-types/actions'
import useSearchEntityFieldTypesReducer from '../../../../state/entities/search-entity-field-types/reducer'

import {
  createCalendarView,
  updateCalendarView,
} from '../../../../state/calendar-views/post-calendar-view/actions'
import usePostCalendarViewReducer from '../../../../state/calendar-views/post-calendar-view/reducer'
import {deleteCalendarView} from '../../../../state/calendar-views/delete-calendar-view/actions'
import useDeleteCalendarViewReducer from '../../../../state/calendar-views/delete-calendar-view/reducer'

// Custom Components
import {useModal} from '../../../../common/Modal'
import {useTranslation} from 'react-i18next'
import {Select} from './Select'
import {DatesToDisplay} from './DatesToDisplay'
import {DisplayFields} from './DisplayFields'
import {ViewColor} from '../ViewColor'

// styles

const PopGroupView = ({open, onClose, data, groups, onSuccess, customColors = [], viewData}) => {
  const {t} = useTranslation()
  const simpleModal = useModal()
  const [group, groupDispatch] = useSearchEntityFieldTypesReducer()
  const [save, saveDispatch] = usePostCalendarViewReducer()
  const [remove, deleteDispatch] = useDeleteCalendarViewReducer()
  const [refColorPicker, setRefColorPicker] = useState(null)

  const [groupView, setGroupView] = useState({
    // user_id: 133619,
    entity_id: -1,
    color: '#FEB237',
    groups: [],
    actions: [],
    display_fields: [],
  })

  const [isDisable, setDisable] = useState(true)
  const isEdit = groupView?.id ? true : false

  const entity_view_ids = _.map(viewData, (val, key) => {
    return val.group_view.entity_id
  })

  const update = (e, k, v) => {
    setGroupView(p => ({...p, [k]: v}))
  }

  const handleChangeGroup = (e, entity) => {
    update(e, 'entity_id', entity.id)
  }

  const handleToggleGroup = (e, k, v) => {
    const _groups = [...groupView.groups]
    _groups[k].active = v
    update(e, 'groups', _groups)
  }

  const handleToggleActions = (e, k, v) => {
    const _actions = [...groupView.actions]
    _actions[k].active = v
    _actions[k].advance_option_key = {start_date: '', end_date: '', is_stamp: true}
    update(e, 'actions', _actions)
  }

  const handleSetActionAdvOpt = (e, k, v) => {
    const _actions = [...groupView.actions]
    _actions[k].advance_option_key = v
    update(e, 'actions', _actions)
  }

  const handleSetDisplayFields = (e, v) => {
    update(e, 'display_fields', v)
  }

  const handleClose = e => {
    onClose()
    setGroupView({
      // user_id: 133619,
      entity_id: -1,
      color: '#FEB237',
      groups: [],
      actions: [],
      display_fields: [],
    })
  }

  const handleConfirm = e => {
    const _confirmFunc = !groupView.id ? createCalendarView : updateCalendarView
    _confirmFunc(saveDispatch, {
      user_id: localStorage.user_id,
      ...groupView,
    }).then(res => {
      onSuccess()
    })
  }

  const handleDelete = e => {
    if (simpleModal) {
      simpleModal.show({
        scheme: 'destructive',
        title: 'Delete View',
        description: 'Are you sure you want to delete this view?',
        buttons: {
          affirmative: {
            label: 'Yes',
            click: (data, modal) => {
              deleteCalendarView(deleteDispatch, {
                user_id: localStorage.user_id,
                ...groupView,
              }).then(res => {
                onSuccess()
              })
              modal.hide()
            },
          },
          negative: {
            label: 'No',
          },
        },
      })
    }
  }

  const handleClickColorPicker = e => {
    setRefColorPicker(e.target)
  }

  // trigger load group data
  useEffect(() => {
    if (groupView.entity_id !== undefined && groupView.entity_id !== -1) {
      searchEntityFieldTypes(groupDispatch, groupView.entity_id, {
        include_actions: false,
        include_related: true,
        field_types: ['DateField', 'DateFormulaField', 'CreatedAtField', 'DateTimeField'],
        currency_items: false,
        with_actions: true,
      })
    }
  }, [groupView.entity_id, groupDispatch])

  //
  useEffect(() => {
    if (!_.isEmpty(group.data)) {
      const _groups = _.map(group.data.fields, f => ({
        field_id: f.id,
        key: f.key,
        active: false,
      }))
      const _actions = _.map(group.data.actions || [], a => ({
        action_id: a.id,
        active: false,
      }))

      setGroupView(p => ({
        ...p,
        groups: _groups.map(g => p.groups.find(pg => pg.field_id === g.field_id) || g),
        actions: _actions.map(a => p.actions.find(pa => pa.action_id === a.action_id) || a),
      }))
    }
  }, [group.data, setGroupView])

  // initialize for mounting
  useEffect(() => {
    if (!data) {
      setGroupView({
        // user_id: ---,
        entity_id: -1,
        color: '#fe8787',
        groups: [],
        actions: [],
        display_fields: [],
      })
    } else {
      const _data = _.pick(data, [
        'user_id',
        'entity_id',
        'color',
        'groups',
        'actions',
        'display_fields',
      ])
      if (data.id) {
        _data['id'] = data.id['$oid'] || data.id
      }
      setGroupView({..._data})
    }
  }, [data, setGroupView])

  useMemo(() => {
    let isDiableGroupAction = true
    if (!_.isEmpty(groupView?.actions)) {
      groupView.actions.map(action_data => {
        if (action_data.active) {
          isDiableGroupAction = false
        }
        return isDiableGroupAction
      })
    }
    if (!_.isEmpty(groupView?.groups)) {
      groupView.groups.map(group_data => {
        if (group_data.active) {
          isDiableGroupAction = false
        }
        return isDiableGroupAction
      })
    }
    if (group.isLoading || groupView.entity_id === -1) {
      isDiableGroupAction = true
    }
    setDisable(isDiableGroupAction)
  }, [group, groupView])

  return (
    <Modal
      style={{position: 'absolute'}}
      className={'ds-modal-wrapper'}
      open={open}
      onClose={onClose}
    >
      <div className="ds-modal-complex ds-modal-complex--lg ds-py-0">
        <div className="ds-flex-row ds-flex-no-spill">
          <div
            className="ds-flex-col ds-flex-no-spill ds-pt-24 ds-pb-20"
            style={{
              flex: '0 0 517px',
              borderRight: '1px solid #D6D8DC',
              paddingRight: 30,
            }}
          >
            <div
              className="ds-modal-header ds-mb-52"
              style={{display: 'flex', justifyContent: 'space-between'}}
            >
              <h4 className="ds-t400r">
                {!isEdit ? t('calendar.view.add.title') : t('calendar.view.edit.title')}
              </h4>
              <ViewColor value={groupView.color} onChange={(e, v) => update(e, 'color', v)} />
            </div>
            <div className="ds-modal-body ds-flex-col ds-mb-32">
              <Select
                disabled={isEdit}
                value={groupView.entity_id}
                label="Group"
                required
                placeholder={t('calendar.view.add.placeholder-select-field')}
                onChange={handleChangeGroup}
                items={groups.data}
                render={(item, index, clickHandle) => {
                  return (
                    <div
                      disabled={entity_view_ids.includes(item.id)}
                      key={index}
                      onClick={e => clickHandle(e, item, index)}
                      className="ds-menu-item"
                    >
                      {item.name}
                    </div>
                  )
                }}
                selectedDisplay={(value, items) => _.find(items, f => f.id === value)?.name}
              />
              <DatesToDisplay
                entity_id={groupView.entity_id}
                group={group}
                groups={groupView.groups}
                actions={groupView.actions}
                handleToggleActions={handleToggleActions}
                handleToggleGroup={handleToggleGroup}
                handleSetActionAdvOpt={handleSetActionAdvOpt}
              />
            </div>
            <div className="ds-modal-footer" style={{height: 32, justifyContent: 'flex-start'}}>
              {isEdit && (
                <button className="ds-btn-destructive" onClick={handleDelete}>
                  {t('calendar.view.edit.btn-delete')}
                </button>
              )}
            </div>
          </div>
          {/* Right Section */}
          <div className="ds-flex-col ds-pt-48 ds-pb-20 ds-pl-30">
            <div className="ds-modal-body ds-mb-32">
              <DisplayFields
                groupView={groupView}
                onChange={handleSetDisplayFields}
                display_fields={groupView.display_fields || []}
              />
            </div>

            <div className="ds-modal-footer">
              <button className="ds-btn-cta ds-mr-8" onClick={handleConfirm} disabled={isDisable}>
                {!isEdit ? t('calendar.view.add.btn-create') : t('calendar.view.edit.btn-create')}
              </button>
              <button className="mdl-cancel ds-btn-secondary" onClick={handleClose}>
                {t('calendar.view.add.btn-cancel')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PopGroupView
